// extracted by mini-css-extract-plugin
export var attachButton = "_cl-8";
export var sendButton = "_cl-2";
export var sendDisabled = "_cl-4";
export var sendEnabled = "_cl-3";
export var sendIcon = "_cl-6";
export var sendIconDisabled = "_cl-7";
export var sendStreaming = "_cl-5";
export var textarea = "_cl-1";
export var wrapper = "_cl-0";